<template>
  <component 
    :color="color" 
    :is="icon" 
    :stroke_width="this.stroke_width" 
    class="item-i icon" 
    :class="size" 
    :active="active" 
    :is_сolored="is_сolored"  
    v-bind="$attrs"
  />
</template>

<script>
import { defineAsyncComponent, shallowRef, watch } from "vue";
import FallbackCircle from "./iconsList/fallback-circle.vue";

export default {
  inheritAttrs: false,
  props: {
    name: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: "c24",
    },
    active: {
      type: Boolean,
      default: true,
    },
    stroke_width: {
      type: [Number, Boolean, String],
      default: '2'
    },
    color: [Boolean, Object, String],
    is_сolored: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const icon = shallowRef(null);

    const loadComponent = async (componentName) => {
      try {
        icon.value = defineAsyncComponent({
          loader: () => import(`@/components/icons/iconsList/${componentName}.vue`),
          errorComponent: FallbackCircle,
          onError: (error, retry, fail, attempts) => {
            // If the icon doesn't exist, use fallback
            console.warn(`Icon "${componentName}" not found, using fallback`);
            fail();
          }
        });
      } catch (error) {
        console.warn(`Failed to load icon "${componentName}", using fallback`);
        icon.value = FallbackCircle;
      }
    };

    watch(
      () => props.name,
      (newName) => {
        if (newName) {
          loadComponent(newName);
        }
      },
      { immediate: true }
    );

    return {
      icon,
    };
  },
};
</script>
